export const questions = {
  account: [{
    question: 'How do I obtain access to the HomeBridge Enhanced Portal?',
    answer: 'Complete the <a href="/users/sign_up">registration form</a> to create an account.',
  },
  {
    question: 'I forgot my password or need to change my password. What should I do?',
    answer:
      'Click the Forgot Password link located under the login fields and follow the prompts to reset your password.',
  },
  {
    question: 'What if my email address changes?',
    answer:
      'Navigate and sign into to the HomeBridge Enhanced Portal. Go to Settings and click on the change email link on the account page.',
  },
  {
    question:
      'What if I need to change my security questions?',
    answer:
      'Navigate and sign into to the HomeBridge Enhanced Portal. Go to Setting and click on the Go to Security Questions available on the security tab.',
  },
  {
    question:
      'What if I receive a notice that my portal account is locked?',
    answer:
      'Click on the link to reset your password or use the Forgot Password link located under the login fields and follow the prompts to reset your password.',
  },
  {
    question:
      'I received an email stating my password is expiring. How do I reset my password?',
    answer:
      'Three options exist to change an expiring password: <br/><br/>i.	Click on the link to reset your password from the expiration email. <br/>ii.	Navigate to Setting and click on the My Password link on the Security tab. <br/>iii.	Click on the Forgot Password link located under the login fields and follow the prompts to reset your password.',
  },
  {
    question:
      'What if there’s a problem with my account status?',
    answer:
      'Follow the instructions on the screen or contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)',
  },
  {
    question: 'I registered for the HomeBridge Enhanced Portal but did not receive an email with a verification link. How do I gain access to the portal?',
    answer:
      'Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)',
  },
  {
    question:
      'I registered for the HomeBridge Enhanced Portal but was not able to verify my account for more than 24 hours. Do I need to register again for the portal?',
    answer:
      'Click the verification link in the welcome email to navigate to the HomeBridge Enhanced Portal. Enter your email address to receive a new verification link and confirm the email address associated with your account.',
  },
  {
    question:
      'Can I register using a shared email?',
    answer:
      'We recognize that it might be easier for your team to register using a shared email, but for security concerns, we do not recommend sharing a password for the HomeBridge Enhanced Portal. It is recommended that each user register using their own personal email address.',
  }],
  systemOperational: [
    {
      question: 'What if my Save Button does not appear to work?',
      answer: 'Verify your request is not in the Draft Requests section under My Tasks in the navigation bar. If the draft request does not exist, contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
    {
      question: 'What if I receive A System Error Has Occurred message?',
      answer: 'Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
    {
      question: 'What if I am experiencing variable performance?',
      answer: 'We recommend accessing the HomeBridge Enhanced Portal using Google Chrome with resolution 1280 x 800. If you are experiencing variable performance, restart your browser. If the problem persists, contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
    {
      question: 'Does the portal time out?',
      answer: 'The HomeBridge Enhanced Portal will time out after 30 minutes of inactivity.'
    },
    {
      question: 'What if I am not able to find what I am expecting from a search?',
      answer: 'Confirm your search criteria are correct. If the problem persists, contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us).'
    },
    {
      question: 'I received an unexpected error. How do I proceed?',
      answer: 'Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
  ],
  general: [
    {
      question: 'How does the HomeBridge Enhanced Portal communicate with my Medical Record system?',
      answer: 'There is not a current integration between the two systems. Clinical notes and other documentation need to be uploaded in the HomeBridge Enhanced Portal.'
    },
    {
      question: 'Who should have access to and utilize the HomeBridge Enhanced Portal?',
      answer: 'Access to the HomeBridge Enhanced Portal is currently available to Post-Acute Care providers.'
    },
    {
      question: 'I submitted a request to CareCentrix by phone, fax, or email. Will my request display in the HomeBridge Enhanced Portal? ',
      answer: 'All in-stay requests submitted to CareCentrix for the health plan are available in the HomeBridge Enhanced Portal.'
    },
    {
      question: 'What health plans are currently supported in Enhanced Portal? ',
      answer: 'Supported health plans for the HomeBridge Enhanced Portal are listed in the <a href="/users/sign_up">registration</a> health plan dropdown. If the member’s health plan is not listed, Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us).'
    },
    {
      question: 'How do I edit my Clinical Template answers after submission?',
      answer: 'Once the request has been submitted, the Clinical Template cannot be changed.'
    },
  ],
  serviceRequest: [
    {
      question: 'What if my rendering location is not displayed on the Rendering Provider selection page?',
      answer: 'Navigate to the Assigned Branches tab in account settings and confirm the location you wish to service the request at is available with the same line of business as the member. If your location is not displayed on the assigned branches tab, please contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us). If the rendering location’s line of business is incorrect, please contact the member’s Health Plan for instructions.'
    },
    {
      question: 'The HomeBridge Enhanced Portal displayed a message saying that CareCentrix is not responsible for my request. What should I do next?',
      answer: 'Please contact the member’s health plan for instructions on how to handle this request.'
    },
    {
      question: 'Where do I find my service header number or my service line number?',
      answer: 'When the request is approved, you will receive a Service Registration Form (SRF). Both the service header number and the service line number can be found on this form.'
    },
    {
      question: 'How do I see a decision letter/fax associated with my request?',
      answer: 'After searching for your request in the request status search, use the actions button and select View Documents to view clinical attachments, letters, and faxes associated with the request.'
    },
    {
      question: 'What is the maximum number of diagnoses I can associate with a request?',
      answer: 'You can have up to 4 diagnoses associated with your request. The HomeBridge Enhanced Portal allows one primary diagnosis, one secondary diagnosis, one tertiary diagnosis, and one other diagnosis.'
    },
    {
      question: 'I entered my request with the wrong primary diagnosis. How do I update my primary diagnosis?',
      answer: 'To change the primary diagnosis, cancel and re-enter your request. However, if a UM Decision has been made, Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us) to edit primary diagnosis.'
    },
    {
      question: 'What do I do if I picked a wrong rendering location to service the request?',
      answer: 'Call CareCentrix at (833) 592-1093 to update the rendering location on an existing request.'
    },
    {
      question: 'The member was discharged from acute care later than expected. How do I change the start date of my request?',
      answer: 'After searching for the request using the Edit Request search, click Edit, and then the edit request action from the dropdown to update the start date of the request.'
    },
    {
      question: 'How do I enter a Continuation of Services request?',
      answer: 'After searching for the request using the Continuation of Services search, click the Continue Services button to enter a Continuation of Services request.'
    },
    {
      question: 'I can’t edit the start date of a Continuation of Services request. How do I update the date?',
      answer: 'Call CareCentrix at (833) 592-1093 to update the date'
    },
    {
      question: 'I am looking for an update on my request. Can I check the status in the HomeBridge Enhanced Portal?',
      answer: 'You can check the status of your request in the HomeBridge Enhanced Portal using the Request Status search under the manage request drop down.'
    },
  ],
  clinicalDocument: [
    {
      question: 'Can I add clinical attachments on a request that I already submitted?',
      answer: 'If a request has been submitted to CareCentrix, then clinical attachments can be added to the request via the HomeBridge Enhanced Portal. To add an attachment, search for the request in the Request Status search, click the Actions button and select add document.'
    },
    {
      question: 'I attempted to attach clinical documents to my request but the portal says the files failed to upload. Can I still attach the documents?',
      answer: 'Try to upload the files again. If the issue persists, contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
    {
      question: 'How do I add attachments while entering a request?',
      answer: 'When entering a request, click on the Browse button under Attachment on the additional information page to select a document. Choose an attachment type and click Upload Document.'
    },
    {
      question: 'What is the size limit of an attachment file?',
      answer: 'A single file cannot exceed 50MB.'
    },
    {
      question: 'Is there a limit to the number of attachments that I can upload?',
      answer: 'There is no limit to the number of attachments. However, a single file cannot exceed 50MB.'
    },
    {
      question: 'What are the supported file types of attachments?',
      answer: 'The HomeBridge Enhanced Portal supports the following document types: BMP, DOC, DOCX, GIF, JFIF, JPEG, JPG, PDF, PNG, PPT, PPTX, RTF, TIF, TIFF, TXT, XLS, XLSX, and EXIF.'
    },
    {
      question: 'Will the UM nurse have access to review any clinical attachments associated with my request in the HomeBridge Enhanced Portal? ',
      answer: 'Yes, the preferred method to provide clinical documentation for CareCentrix UM nurse is via the HomeBridge Enhanced Portal.'
    },
  ],
  support: [
    {
      question: 'What if I need additional training?',
      answer: 'Review the <a href="/education/index">Education Center</a> for a list of training documents for the HomeBridge Enhanced Portal. For additional training needs, Contact CareCentrix by clicking on the <a href="/support/issues/new">Contact Us</a> link under the CareCentrix logo (Contact Us)'
    },
    {
      question: 'How do I contact support?',
      answer: 'Contact CareCentrix by clicking on the Contact Us link under the CareCentrix'
    },
    {
      question: 'Is there a user guide on how to use the HomeBridge Enhanced Portal?',
      answer: 'Yes, you can find a <a href="/education/index">Portal User Guide</a> on the Education Center'
    },
  ]
};